<template>
  <table class="table-auto">
    <thead>
      <th v-for="(heading, headingIndex) in headers" :key="headingIndex" class="text-center p-3">
          {{ heading }}
      </th>
    </thead>
    <tbody>
      <tr v-for="(row, rowIndex) in rows" :key="rowIndex" class="text-center" @click="navigateTo(row)">
        <td v-for="(data, dataIndex) in row.data" :key="dataIndex" v-html="data" class="border-t py-2 infline-flex flex-row justify-center">
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  name: 'vue-table',

  props: {
    headers: Array,
    rows: Array
  },

  methods: {
    navigateTo (row) {
      if (row.route) {
        this.$router.push(row.route)
      }
    }
  },

  modules: {
    tableLayout: 'responsive'
  }
}
</script>
